<template>
  <div class="container">
    <ml-table
      ref="operationLogTableRef"
      title="操作日志"
      :url="$API.log_page_post"
      :defaultConfig="listTableConfig"
      :mountQuery="true"
    >
    </ml-table>
  </div>
</template>

<script>
export default {
  name: 'operationLog',
  data() {
    return {
      listTableConfig: {
        columns: [
          {
            prop: 'realName',
            label: '操作人',
            width: 130,
            filter: {
              label: '操作人',
              prop: 'realName',
            },
          },
          {
            prop: 'createdAt',
            label: '操作时间',
            width: 200,
            filter: {
              label: '操作时间',
              prop: 'createdAt',
              component: 'DateRange',
              start: 'startTime',
              end: 'endTime',
            },
          },
          {
            prop: 'title',
            label: '操作',
          },
        ],
      },
    };
  },
  methods: {},
};
</script>
